import { CHARGE_STATUS_COLORS, StackedBarChart } from "@/components/charts";
import type { ChargeItemsStatusDay, DashboardDateRange } from "./dashboard-types";
import { DashboardCard } from "./dashboard-card";
import { DateRangeFilter } from "./date-range-filter";

export interface ChargeItemsStatusCardProps {
    items: ChargeItemsStatusDay[];
    dateRange: DashboardDateRange;
    onDateRangeChange: (range: DashboardDateRange) => void;
}

export function ChargeItemsStatusCard({ items, dateRange, onDateRangeChange }: ChargeItemsStatusCardProps) {
    return (
        <DashboardCard
            title="Charge Items - Status by day"
            className="min-h-[420px]"
            action={<DateRangeFilter value={dateRange} onChange={onDateRangeChange} />}
        >
            <div className="h-[320px] w-full">
                <StackedBarChart
                    className="h-full w-full"
                    ariaLabel="Charge items status by day"
                    labels={items.map((item) => item.label)}
                    datasets={[
                        {
                            label: "Not added to Report",
                            data: items.map((item) => item.notAddedToReport),
                            backgroundColor: CHARGE_STATUS_COLORS.notAddedToReport,
                        },
                        {
                            label: "Added to Report",
                            data: items.map((item) => item.addedToReport),
                            backgroundColor: CHARGE_STATUS_COLORS.addedToReport,
                        },
                        {
                            label: "Review",
                            data: items.map((item) => item.review),
                            backgroundColor: CHARGE_STATUS_COLORS.review,
                        },
                        {
                            label: "Accounting Review",
                            data: items.map((item) => item.accountingReview),
                            backgroundColor: CHARGE_STATUS_COLORS.accountingReview,
                        },
                        {
                            label: "Approved",
                            data: items.map((item) => item.approved),
                            backgroundColor: CHARGE_STATUS_COLORS.approved,
                        },
                    ]}
                />
            </div>
        </DashboardCard>
    );
}
